import { combineReducers } from 'redux';
import merchantRegistrationsCsv from './ImportCsv/reducer';
import merchantRegistrationsForms from './RegistrationForms/reducer';

export default combineReducers({
  merchantRegistrationsCsv,
  merchantRegistrationsForms
});
